"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowIsDiscontinuedErrorInfo = void 0;
const shouldShowIsDiscontinuedErrorInfo = products => {
  if (products.length > 0) {
    return products.every(product => product.isDiscontinuedAndCannotBeSold);
  }
  return false;
};
exports.shouldShowIsDiscontinuedErrorInfo = shouldShowIsDiscontinuedErrorInfo;
